import { useQuery } from "@tanstack/react-query";
import { getAllTutorialRatings, getAllTutorialCompletedCounts } from '@/lib/supabase';


//export function useTutorialStats(documentId: string) {
//  const completedCountQuery = useQuery({
//    queryKey: ['tutorial', documentId, 'completedCount'],
//    queryFn: () => getTutorialCompletedCount(documentId),
//  });

//  const ratingQuery = useQuery({
//    queryKey: ['tutorial', documentId, 'rating'],
//    queryFn: () => getTutorialAverageRating(documentId),
//  });

//  return {
//    completedCount: completedCountQuery.data ?? 0,
//    rating: ratingQuery.data ?? 0,
//    isLoading: completedCountQuery.isLoading || ratingQuery.isLoading,
//    isError: completedCountQuery.isError || ratingQuery.isError,
//  };
//}

export function useAllTutorialStats() {
  const ratingsQuery = useQuery({
    queryKey: ['tutorials', 'all-ratings'],
    queryFn: async () => {
      const ratings = await getAllTutorialRatings();
      return ratings.reduce<Record<string, number>>((acc, { id, rating }) => ({
        ...acc,
        [id]: rating
      }), {});
    },
  });

  const completedCountsQuery = useQuery({
    queryKey: ['tutorials', 'all-completed-counts'],
    queryFn: async () => {
      const counts = await getAllTutorialCompletedCounts();
      return counts.reduce<Record<string, number>>((acc, { id, count }) => ({
        ...acc,
        [id]: count
      }), {});
    },
  });

  return {
    ratings: ratingsQuery.data ?? {},
    completedCounts: completedCountsQuery.data ?? {},
    isLoading: ratingsQuery.isLoading || completedCountsQuery.isLoading,
    isError: ratingsQuery.isError || completedCountsQuery.isError,
  };
}
